import styled from 'styled-components';

const SkeletonSliderReviewStyle = styled.div`
	--sizeItemSlid: calc((100vw - 2 * var(--contPaddingLR) - 2 * var(--gutter)) / 3);
	--swiperSlideWidth: calc(var(--sizeItemSlid) - 5px);
	--distanceSliderT: var(--sp9x);

	display: flex;
	margin-top: var(--distanceSliderT);
	margin-bottom: var(--sectionDistance);

	.image-cont {
		--proportion: 0;

		img {
			position: relative !important;
			object-fit: contain;
		}
	}

	.swiper {
		padding: 0 var(--contPaddingLR);
		display: flex;
	}

	.swiper-wrapper {
		cursor: grab;
		user-select: none;
	}

	.swiper-slide {
		width: var(--swiperSlideWidth);
		margin-right: var(--gutter);
		height: unset;

		&:last-child {
			margin-right: 0 !important;
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceSliderT: var(--sp7x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceSliderT: var(--sp6x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceSliderT: var(--sp4x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizeItemSlid: calc((100vw - 2 * var(--contPaddingLR) - 2 * var(--gutter)) / 2);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeItemSlid: calc((100vw - 2 * var(--contPaddingLR) - 2 * var(--gutter)) / 4 * 3);
		--distanceSliderT: var(--sp3x);
	}
`;

export default SkeletonSliderReviewStyle;
